import { ReactElement } from 'react'

import { GetStaticPaths, GetStaticProps } from 'next'

import ExchangeFaq from '../../exchange/exchange-faq'
import ManageMoneyWallet from '../../wallet/manage-money'

import CoinWalletCryptoPlatform from '../../wallet-coin/btc/crypto-platform'
import CoinWalletHeader from '../../wallet-coin/btc//header'
import CoinWalletHowToGet from '../../wallet-coin/btc//how-to-get'
import CoinWalletWorthRelyingOn from '../../wallet-coin/btc/worth-relying-on'

import { WalletCoinsListStrapi } from '../../../store/fetchers/coinsWallet/interfaces/wallet-coins-list-strapi.interface'

import { getCoins, getCoinByUrl } from '../../../store/fetchers/coinsWallet/services'

import styles from '../../wallet-coin/btc/styles.module.scss'
import { useHeader } from '../../../utils/use-header'
import { useTranslation } from 'utils/use-translation'

const WalletCoinStrapi = ({
  WalletsCoinsListStrapi,
}: {
  WalletsCoinsListStrapi: WalletCoinsListStrapi
}): ReactElement => {
  const { t, locale, replacePlaceholders } = useTranslation()

  const placeholders = {
    name: WalletsCoinsListStrapi?.name,
    ticker: WalletsCoinsListStrapi?.ticker
  }

  const head = useHeader(
    locale === 'en' && WalletsCoinsListStrapi?.pageTitle
      ? WalletsCoinsListStrapi?.pageTitle 
      : replacePlaceholders(t('title_wallet'), placeholders),
    locale === 'en' && WalletsCoinsListStrapi?.pageDescription 
      ? WalletsCoinsListStrapi?.pageDescription 
      : replacePlaceholders(t('desc_wallet'), placeholders)
  )

  const questions = [
    {
      title: t('what_is_wallet'),
      answer: t('what_is_wallet_answer'),
    },
    {
      title: t('how_get_wallet'),
      answer: t('how_get_wallet_answer'),
    },
    {
      title: t('what_is_best_wallet'),
      answer: t('what_is_best_wallet_answer'),
    },
    {
      title: t('how_set_up_wallet'),
      answer: t('how_set_up_wallet_answer'),
    },
    {
      title: t('how_move_crypto'),
      answer: t('how_move_crypto_answer'),
    },
  ]

  return (
    <>
      {WalletsCoinsListStrapi && (
        <div className={styles.coinWallet}>
          {head}
          <CoinWalletHeader pageCurrency={WalletsCoinsListStrapi} />
          <CoinWalletHowToGet pageCurrency={WalletsCoinsListStrapi} />
          <CoinWalletCryptoPlatform pageCurrency={WalletsCoinsListStrapi} />
          <ManageMoneyWallet className={styles.manageMoney} />
          <CoinWalletWorthRelyingOn pageCurrency={WalletsCoinsListStrapi} />
          <section className={styles.wallet__section_faq}>
            <h2>{t('faq')}</h2>
            <ExchangeFaq className={styles.faq}
              hasTitle={false}
              questions={locale === 'en' 
              ? WalletsCoinsListStrapi.questions?.questions || questions 
              : questions} />
          </section>
        </div>
      )}
    </>
  )
}

type Params = {
  coin: string
}

export const getStaticProps: GetStaticProps = async ({ params }) => {
  const coin = Array.isArray(params?.coin) ? params.coin[0] : params?.coin  
  if (!coin) {
    return {
      notFound: true,
    }
  }

  const res = await getCoinByUrl(coin)  
  if (!res || !res.data || !res.data.attributes) {
    return {
      notFound: true,
    }
  }

  return { props: { WalletsCoinsListStrapi: res.data.attributes } }
}

export const getStaticPaths: GetStaticPaths<Params> = async ({ locales }) => {
  const res = await getCoins()  
  if (!res || !res.data) {
    return { paths: [], fallback: false }
  }

  const WalletsCoinsListStrapi = res.data

  const paths = WalletsCoinsListStrapi.flatMap((coin) =>
    locales.map((locale) => ({
      params: { coin: coin.attributes.coinPageUrl },
      locale,
    }))
  )

  return { paths, fallback: false }
}

export default WalletCoinStrapi
